module.exports = __webpack_public_path__ + "static/media/Ebook.3882c42d.png";